import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { RootEntityService } from './root-entity.service';
import { MainDataService } from '../services/main-data.service';

@Injectable({ providedIn: 'root' })
export class LogoService {
  organizationLogo$ =
    this.rootEntityService.currentRootEntityUpdatedRealtimeData$.pipe(
      map((rootEntity) =>
        rootEntity?.logo ? `url(${rootEntity.logo})` : null,
      ),
    );

  projectLogo$ = this.mainDataService.projectSettings$.pipe(
    map((projectSettings) =>
      projectSettings?.logo ? `url(${projectSettings.logo})` : null,
    ),
  );

  logo$ = combineLatest([this.organizationLogo$, this.projectLogo$]).pipe(
    map(([organizationLogo, projectLogo]) => organizationLogo || projectLogo),
  );

  constructor(
    private mainDataService: MainDataService,
    private rootEntityService: RootEntityService,
  ) {}
}
